import * as types from "./actionType";

const initialState = {
  elements: null,
  elementsStatus: false,
};

function labelAndPlaceholderReducers(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_LABELS_AND_PLACEHOLDER:
      return {
        ...state,
        elements: null,
        elementsStatus: true,
      };
    case types.FETCH_LABELS_AND_PLACEHOLDER_SUCCESS:
      return {
        ...state,
        elements: action.payload,
        elementsStatus: false,
      };
    case types.FETCH_LABELS_AND_PLACEHOLDER_FAILED:
      return {
        ...state,
        elements: null,
        elementsStatus: false,
      };

    default:
      return state;
  }
}

export default labelAndPlaceholderReducers;
// userCreationElements: {
//   backButtonElement: "Back",
//   femaleElement: "Female",
//   futureContactAll: "All",
//   selectGenderLabel: "Select Your Gender*",
//   lNamePlaceholder: "Last Name",
//   countryLabel: "Country*",
//   selectCountryElement: "Select Country",
//   selectCallingCodeElement:"Select Calling Code"
//   clubMemberLabel: "Club Member",
//   lastNameValidationElement: "Enter Last Name",
//   mobilePlaceholder: "Mobile Number",
//   methodOfContactEmail: "Email",
//   termAndConditionValidationElement: "Please Accept terms and conditions",
//   countryValidationElement: "Country not selected",
//   firstNameValidationElement: "Enter First Name",
//   fNameLabel: "First Name*",
//   methodOfContactPhone: "Phone",
//   fNamePlaceholder: "First Name",
//   methodOfContactLabel: "Method of Contact",
//   futureContactCommunity: "Community Activities",
//   dobValidationElement: "Date of Birth not selected",
//   dobLabel: "Date Of Birth*",
//   callingCodeLabel: "Calling Code*",
//   clubMemberDescription: "Make me a member of the Riders Club",
//   callingCodeValidationElement: "Calling code not selected",
//   maleElement: "Male",
//   futureContactLabel: "Future Contact",
//   disclaimerLabel: "Disclaimer",
//   mobileLabel: "Mobile Number*",
//   submitButtonElement: "Create Account",
//   emailPlaceholder: "Email",
//   futureContactPromotion: "Promotion & News",
//   headingElement: "User Registration",
//   futureContactSurveys: "Surveys & Research",
//   iAcceptElement:"I accept the",
//   termAndConditionElement:" Terms and Conditions ",
//   asWellAsElement:" as well as ",
//   privacyElement:"Privacy policy*",
//   lNameLabel: "Last Name*",
//   dobPlaceholder: "Select Date",
//   disclaimerDescription:
//     "By signing this form/checking this box you acknowledge and agree that we may use the information you share with us to communicate with you through e-mails text messages and calls in order to provide our product or service related information and/or for promotional and marketing purposes. All information provided will be secured and processed as per our privacy policy.",
//   emailLabel: "Email*",
//   otherElement: "Prefer not to say",
//   existingUserLabel: "Existing User?*",
//   yesExistingUserLabel: "Yes",
//   noExistingUserLabel: "No",
// },
// eventDetailElement: {
//   backButtonElement: "Back",
//   updateButtonElement: "Update",
//   campaignCodeElement: "Campaign Code",
//   startPointElement: "Start Point",
//   cityElement: "City",
//   advanceBookingElement: "Advanced Booking",
//   rejectionButtonElement: "Reject",
//   countryElement: "Country",
//   hospitalityElement: "Hospitality",
//   addUserElement: "Add Participant",
//   stateElement: "State",
//   disApproveButtonElement: "Reject",
//   registrationFeeElement: "Registration Fee",
//   eventNameElement: "Event Name",
//   tabJoinEventElement: "Join Event",
//   testRideElement: "Test Rides",
//   moderationStatusElement: "Moderation Status",
//   coordinatorMobileElement: "Event Coordinator's Mobile Number",
//   startDateElement: "Start Date",
//   sourceLongElement: "Event Longitude",
//   coordinatorNameElement: "Event Coordinator's Name",
//   placeAvailableElement: "Places Available",
//   tabDetailElement: "Detail",
//   sourceLatElement: "Event Latitude",
//   coordinatorEmailElement: "Event Coordinator's Email",
//   headingElement: "Event Details",
//   rejectionElement: "Rejection Reason",
//   approveButtonElement: "Approve",
//   startTimeElement: "Start Time",
//   eventDescriptionElement: "Description",
//   eventStatusElement: "Event Status",
// },
// loginElement: {
//   emailPlaceholder: "Email / Mobile",
//   loginButtonElement: "Login",
//   passwordPlaceholder: "Password",
//   forgotPasswordLinkElement: "Forgot Password?",
// },
// rideListTableElement: {
//   rideNameElement: "Ride Name",
//   statusLabelElement: "Status",
//   rideStatusElement: "Ride Status",
//   branchNameElement: "Branch Name",
//   headingElement: "Rides",
//   campaignCodeElement: "Campaign Code",
//   statsElement: "State",
//   noRecordsFoundElement: "No records to display",
//   moderationStatusElement: "Moderation Status",
//   actionsElement: "Actions",
//   cityElement: "City",
//   rideTypeElement: "Ride Duration",
//   countryElement: "Country",
//   pendingElement: "Pending",
//   approvedElement: "Approved",
//   rejectedElement: "Rejected",
//   detailPageElement: "Detail Page"
// },
// onBoardListElements: {
//   startDateLabelElement: "Start Date",
//   emailPlaceholderElement: "Email",
//   endDateLabelElement: "End Date",
//   searchButtonElement: "Search",
//   ClubMemberElement: "Club Member",
//   totalCountElement: "Total Count - ",
//   noRecordsFoundElement: "No records to display",
//   startDatePlaceHolderElement: "Select Start Date",
//   filterButtonElement: "Filter",
//   clearFilterElement: "Clear Filter",
//   emailValidationElement: "Email cannot be empty",
//   dateValidationElement: "Dates cannot be empty",
//   exportToExcelButton: "Export To Excel",
//   lastNameElement: "Last Name",
//   headingElement: "Registered Users",
//   CreatedOnElement: "Created on",
//   emailLabelElement: "Email",
//   fistNameElement: "First Name",
//   CountryElement: "Country",
//   endDatePlaceHolderElement: "Select End Date",
//   CountryLabel: "All Countries",
//   selectStateLabel: "Select State",
//   selectCityLabel: "Select City",
//   sourceElement: "Source",
// },
// otpVerifyElement: {
//   backButtonElement: "Back",
//   sendOTPButtonElement: "Enter New Password",
//   verifyButton: "Verify",
//   otpPlaceholder: "Enter OTP",
// },
// joinWebUserListing: {
//   moderationStatusDetailElement: "Moderation Status",
//   fNameDetailElement: "First Name",
//   paymentLabel: "Select Method",
//   rideStatusDetailElement: "Ride Status",
//   paymentMethodPlaceHolderElement: "Enter Payment Method",
//   paymentMethodLabelElement: "Enter Payment Method",
//   mobilePlaceholder: "Mobile Number (exclude prefix '0')",
//   noRecordsFoundElement: "No records to display",
//   phoneValidationElement:
//     "Phone Length should be more than 7 and less than 16",
//   emailValidationElement: "Email cannot be empty",
//   rejectionButtonElement: "Reject",
//   lNameDetailElement: "Last Name",
//   paymentMethodElement: "Payment Method",
//   unJoinedButtonElement: "Reject",
//   joinButtonElement: "Approve",
//   lNameElement: "Last Name",
//   moderationStatusElement: "Moderation Status",
//   statusLabel: "Status",
//   mobileLabel: "Mobile Number",
//   submitButtonElement: "Submit",
//   rideStatusElement: "Ride Status",
//   phoneEmptyValidationElement: "Phone cannot be empty",
//   emailPlaceholder: "Email",
//   fNameElement: "First Name",
//   rejectionElement: "Rejection Reason",
//   "emailLabel Email": "Email",
//   pendingElement: "Pending",
//   approvedElement: "Approved",
//   rejectedElement: "Rejected",
//   mobileElement: "Phone",
//   cashPaymentMethodElement:"Cash",
//   netBankingPaymentMethodElement: "Net Banking",
//   cardPaymentMethodElement: "Card",
//   otherPaymentMethodElement: "Others",
//   backButtonElement: "Back",
// },
// userListingFilterElements: {
//   phoneEmptyValidationElement: "Phone cannot be empty",
//   emailPlaceholder: "Email",
//   searchButtonElement: "Search",
//   headingElement: "User Registration",
//   createUserElement: "Create User",
//   clearFilterButtonElement: "Clear Filter(s)",
//   mobilePlaceholder: "Mobile Number (exclude prefix '0')",
//   phoneCharValidationElement:
//     "Phone Length should be more than 7 and less than 16",
//   emailEmptyValidationElement: "Email cannot be empty",
//   emailLabel: "Email",
//   mobileLabel: "Mobile Number",
// },
// memberShipDetailElements: {
//   backButtonElement: "Back",
//   modelNameLabel: "Model Name",
//   vehicleNotFoundText:
//     "Note : Vehicle details are required to complete the registration",
//   branchIdLabel: "Branch Id",
//   countryLabel: "Country",
//   promotionsLabel: "Promotion & News",
//   surveyLabel: "Survey and Search",
//   vinPlaceholder: "Enter VIN",
//   vinCharValidationElement:
//     "Please enter a valid VIN code. It should have 17 digits and should not contain symbols",
//   subHeadingVehicleElement: "Vehicle Details",
//   subHeadingGdprConsentsElement: "GDPR Consents",
//   motorCycleValidationElement: "Motorcycle not found",
//   fNameLabel: "First Name",
//   vinEmptyValidationElement: "VIN cannot be empty",
//   phoneLabel: "Phone",
//   vinLabel: "VIN",
//   rejectModelButtonElement: "Reject",
//   modelCodeLabel: "Model Code",
//   subHeadingUserElement: "User Details",
//   rejectButtonElement: "Reject",
//   registrationNumberLabel: "Registration Number",
//   updateVinButtonElement: "Update VIN",
//   rejectionModelLabel: "Rejection Reason",
//   branchPrincipalNameLabel: "Branch Name",
//   callingCodeLabel: "Calling Code",
//   moderationLabel: "Moderation Status",
//   emailConsentsLabel: "Email",
//   subHeadingBranchElement: "Branch Details",
//   modelColorLabel: "Model Color",
//   allPromotionsLabel: "All Promotions",
//   mobileLabel: "Mobile Number",
//   branchCodeLabel: "Branch Code",
//   branchNotFoundText:
//     "Note : Branch details are required to complete the registration",
//   cityLabel: "City",
//   headingElement: "Riders Application",
//   lNameLabel: "Last Name",
//   communityActivitiesLabel: "Community Activities",
//   stateLabel: "State",
//   gdprNotFoundText:
//     "Note : Consents are required to complete the registration",
//   approveButtonElement: "Approve",
//   emailLabel: "Email Id",
//   hasRecievedGiftsLabel: "Gift Recieved?",
//   createdAtLabel: "CreatedAt",
//   updatedAtLabel: "UpdatedAt",
//   confirmationLabel: "Confirmation",
//   validationElement: "Are you sure you want to"
//   confirmButtonElement: "Confirm",
//   vinDetailHeadingElement: "Vin Details"
// },
// branchCreationElement: {
//   addressLineTwoLabel: "Address Line 2",
//   backButtonElement: "Back",
//   descriptionPlaceHolderElement: "Description",
//   weeklyOffLabel: "Weekly Off",
//   clubCoordinatorPlaceholder: "Club Coordinator's Name",
//   phoneNumberLabel: "Phone Number*",
//   dealerNamePlaceholder: "Dealer Name",
//   countryValidationElement: "Country cannot be empty",
//   latitudeLabel: "Latitude*",
//   branchPrincipalNamePlaceholder: "Branch Name",
//   dealerIdPlaceholder: "Dealer Id",
//   dealerIdLabel: "Dealer Id",
//   descriptionLabelElement: "Description",
//   descriptionGalleryPlaceholderElement: "Enter Description",
//   galleryAddElement: "Add",
//   galleryHastagPlaceholderElement: "Enter Hastags" ,
//   galleryHastagLabelElement: "Hastags" ,
//   galleryHeadingElement: "Gallery",
//   imageValidationElement:
//     "only '.jpg' , '.jpeg' , '.png' file types are accepted",
//   instagramUrlPlaceholder: "Instagram URL",
//   phoneNumberPlaceholder: "Phone Number",
//   clubCoordinatorNameLabel: "Club Coordinator's Name*",
//   stateValidationElement: "State cannot be empty",
//   branchCodeLabel: "Branch Code",
//   addressLineThreeLabel: "Address Line 3",
//   businessHourPlaceholder: "Business Hours",
//   cityLabel: "City*",
//   dealerNameLabel: "Dealer Name",
//   pinCodeLabel: "Pincode*",
//   stateLabel: "State*",
//   updateHeadingElement: "Branch Update",
//   emailLabel: "Email ID / Store ID*",
//   addressLineTwoPlaceholder: "Address Line 2",
//   countryLabel: "Country*",
//   businessHourLabel: "Business Hours",
//   createHeadingElement: "Branch Creation",
//   cityValidationElement: "City cannot be empty",
//   phoneValidationElement:
//     "Phone Length should be more than 7 and less than 16",
//   webUrlLabel: "Website Page URL",
//   addressLineThreePlaceholder: "Address Line 3",
//   weeklyOffPlaceholder: "Weekly Off",
//   landmarkPlaceholder: "Landmark",
//   subHeadingPersonalInformationElement: "PERSONAL INFORMATION",
//   branchPrincipalNameLabel: "Branch Name*",
//   addressLineOnePlaceholder: "Address Line 1",
//   instagramUrlLabel: "Instagram URL",
//   subHeadingMainInformationElement: "MAIN INFORMATION",
//   landmarkLabel: "Landmark",
//   longitudePlaceholder: "Longitude",
//   alternatePhoneNumberLabel: "Alternate Phone Number",
//   pinCodePlaceholder: "Pincode",
//   facebookUrlPlaceholder: "Facebook URL",
//   facebookUrlLabel: "Facebook URL",
//   longitudeLabel: "Longitude*",
//   submitButtonElement: "Submit",
//   latitudePlaceholder: "Latitude",
//   emailPlaceholder: "Email ID / Store ID",
//   addressLineOneLabel: "Address Line 1*",
//   alternatePhoneNumberPlaceholder: "Alternate Phone Number",
//   branchCodePlaceholder: "Branch Code",
//   webUrlPlaceholder: "Website Page URL",
//   addressHeadingElement: "Address",
// 	 nameElement: "Name",
//   distanceFromElement: "Distance From"
// },
// rideCreateElement: {
//   backButtonElement: "Back",
//   registrationDateValidationElement: "Select Last Date of Registration",
//   cityLabelElement: "City*",
//   sourceLongLabelElement: "Source Longitude*",
//   descriptionLabelElement: "Description",
//   registrationFeePlaceHolderElement: "Registration Fee",
//   totalDistanceValidationElement: "Enter Total Distance",
//   totalDistancePlaceHolderElement: "Distance",
//   rideNamePlaceHolderElement: "Ride Name",
//   tripDurationLabelElement: "Estimated Trip Duration (In Hours)",
//   countryValidationElement: "Select Country",
//   sourceLatLabelElement: "Source Latitude*",
//   assemblingTimeLabelElement: "Start Time*",
//   sourceLatPlaceHolderElement: "Source Latitude",
//   terrainTypePlaceHolderElement: "Terrain Type",
//   rideNameValidationElement: "Enter Ride Name",
//   rideStartDatePlaceHolderElement: "Ride Start Date",
//   descriptionLabelElement: "Description",
//   startPointLabelElement: "Start Point*",
//   assemblingTimePlaceHolderElement: "Start Time",
//   terrainTypeLabelElement: "Terrain Type",
//   rideChampionPlaceHolderElement: "Ride Coordinator's Name",
//   campaignCodeValidationElement: "Enter Campaign Code",
//   rideChampionLabelElement: "Ride Coordinator's Name",
//   rideTypeValidationElement: "Enter Ride Duration",
//   userMaxCountValidationElement: "Enter Rides Capacity",
//   addWayPointsButtonElement: "Add Way Point",
//   destinationLongLabelElement: "Destination Longitude*",
//   difficultLevelElement: "Difficulty Level",
//   rideEndDateValidationElement: "Select Ride End Date",
//   startTimeValidationElement: "Select Start Time",
//   stateValidationElement: "Select State",
//   destinationLongPlaceHolderElement: "Destination Longitude",
//   countryLabelElement: "Country*",
//   destinationLatLabelElement: "Destination Latitude*",
//   rideStatusElement: "Ride Status*",
//   durationValidationElement: "Enter Estimated Trip Duration",
//   headingElement: "Create a Ride",
//   rideEndDateLabelElement: "Ride End Date*",
//   userMaxCountElement: "Rides capacity*",
//   campaignCodeLabelElement: "Campaign Code",
//   stateLabelElement: "State*",
//   rideStartDateLabelElement: "Ride Start Date*",
//   endPointValidationElement: "Select End Point",
//   rideEndDatePlaceHolderElement: "Ride End Date",
//   startPointValidationElement: "Select Start Point",
//   rideLevelPlaceHolderElement: "Ride Duration",
//   lastDateRegisterLabelElement: "Last Date of Registration*",
//   campaignCodePlaceHolderElement: "Campaign Code",
//   easyElement: "Easy",
//   rideStartDateValidationElement: "Select Ride Start Date",
//   cityValidationElement: "Select City",
//   userMaxCountPlaceHolderElement: "Enter Rides Capacity",
//   mediumElement: "Medium",
//   rideChampionMobileLabelElement: "Ride Coordinator's Mobile Number",
//   rideChampionMobilePlaceHolderElement: "Ride Coordinator's Mobile Number",
//   endPointLabelElement: "End Point*",
//   totalDistanceLabelElement: "Estimated Total Distance (In KM)",
//   lastDateRegisterPlaceHolderElement: "Last Date of Registration",
//   destinationLatPlaceHolderElement: "Destination Latitude",
//   rideStatusValidationElement: "Select Ride Status",
//   statePlaceHolderElement: "Enter State",
//   rideNameLabelElement: "Ride Name*",
//   rideLevelLabelElement: "Ride Duration",
//   tripDurationPlaceHolderElement: "Trip Duration",
//   submitButtonElement: "Submit",
//   difficultElement: "Difficult",
//   registrationFeeLabelElement: "Registration Fee",
//   sourceLongPlaceHolderElement: "Source Longitude",
//   cityPlaceHolderElementRide: "Enter City",
//   wayPointsLabelElement: "Way Points",
//   searchPlacesElement: "Search Places ...",
//   actualDistanceLabelElement: "Actual distance (in km)",
//   actualDistancePlaceHolderElement: "Actual Distance",
//   selectRideTypeElement: "Select Type",
//   redirectionalUrl: "Redirection Url",
//   redirectionalUrlPlaceHolderElement: "Enter Link",
// },
// vehicleOnBoardingElements: {
//   dateOfPurchasePlaceholder: "Purchase Date",
//   registrationNumberPlaceholder: "Enter Registration Number",
//   vinPlaceholder: "Enter VIN",
//   vinValidationElement: "Enter VIN",
//   selectVariantValidationElement: "Select variant",
//   purchaseDateValidationElement: "Select Purchase date",
//   vinCharValidationElement:
//     "Please enter a valid VIN code. It should have 17 digits and should not contain symbols",
//   selectMotorCycleValidationElement: "Select motorcycle",
//   subHeadingElement: "Vehicle",
//   variantLabel: "Variant*",
//   submitButtonElement: "Submit",
//   motorCycleLabel: "Motorcycle*",
//   vinLabel: "VIN*",
//   headingElement: "Vehicle Application",
//   registrationNumberLabel: "Registration Number*",
//   regNumberValidationElement: "Enter Registration number",
//   dateOfPurchaseLabel: "Date Of Purchase*",
//   selectMotorCycleElement: "Select Motorcycle",
//   selectVariantElement: "Select Variant",
//   vehicleInformationHeadingElement: "VEHICLE INFORMATION",
//   motorcycleNameElement: "Motorcycle Name - ",
//   motorcycleColorElement: "Motorcycle Color -",
//   vINElement: "VIN -",
//   registrationNumberElement: "Registration Number -",
//   purchaseDateElement: "Purchase Date -",
//   noVehiclesToShowElement: "No Vehicles To Show",
//   addNewVariantLabel: "Add New Variant",
//   addNewVariantPlaceholder: "Add Variant",
// },
// branchDetailElements: {
//   addressLineTwoLabel: "Address Line 2",
//   backButtonElement: "Back",
//   countryLabel: "Country",
//   businessHourLabel: "Business Hours",
//   updateButtonElement: "Update",
//   weeklyOffLabel: "Weekly Off",
//   phoneNumberLabel: "Phone Number",
//   latitudeLabel: "Latitude",
//   rejectModelButtonElement: "Reject",
//   dealerIdLabel: "Dealer Id",
//   dealerStatusLabel: "Dealer Status",
//   branchStatusLabel: "Branch Status",
//   subHeadingTestimonialsElement: "TESTIMONIALS",
//   subHeadingPersonalInformationElement: "PERSONAL INFORMATION",
//   rejectionModelLabel: "Rejection Reason",
//   dealerWebUrlLabel: "Dealer's Website URL",
//   subHeadingMainInformationElement: "MAIN INFORMATION",
//   dynamicTitleLabel: "Title:",
//   landmarkLabel: "Landmark",
//   dynamicAuthorLabel: "Author:",
//   clubCoordinatorNameLabel: "Club Coordinator's Name",
//   alternatePhoneNumberLabel: "Alternate Phone Number",
//   dealerPrincipalNameLabel: "Dealer Principal Name",
//   addTestimonialsButtonElement: "Add Testimonial",
//   longitudeLabel: "Longitude",
//   branchCodeLabel: "Branch Code",
//   addressLineOneLabel: "Address Line 1",
//   addressLineThreeLabel: "Address Line 3",
//   cityLabel: "City",
//   dealerNameLabel: "Dealer Name",
//   pinCodeLabel: "Pincode",
//   stateLabel: "State",
//   disapproveButtonElement: "Reject",
//   approveButtonElement: "Approve",
//   emailLabel: "Email",
// },
// forgotPasswordElement: {
//   backButtonElement: "Back",
//   emailPlaceholder: "Email / Mobile",
//   sendOTPButtonElement: "Send OTP",
// },
// dealerDetailElements: {
//   addressLineTwoLabel: "Address Line 2",
//   backButtonElement: "Back",
//   countryLabel: "Country",
//   businessHourLabel: "Business Hours",
//   weeklyOffLabel: "Weekly Off",
//   branchNameLabel: "Branch Name",
//   branchTypeIdentifierLabel: "Branch Type Identifier",
//   phoneNumberLabel: "Phone Number",
//   latitudeLabel: "Latitude",
//   noBranchFoundText: "No Branches Available",
//   addButtonElement: "Add",
//   dynamicBranchCountryLabel: "Country:",
//   dynamicBranchCityLabel: "City:",
//   dealerStatusLabel: "Dealer Status",
//   dealerIdLabel: "Dealer Id",
//   subHeadingPersonalInformationElement: "PERSONAL INFORMATION",
//   googlePlaceIDLabel: "Google Place ID",
//   dynamicBranchCodeLabel: "Branch Code:",
//   dealerWebUrlLabel: "Dealer's Website URL",
//   subHeadingMainInformationElement: "MAIN INFORMATION",
//   landmarkLabel: "Landmark",
//   dynamicBranchStateLabel: "State:",
//   clubCoordinatorNameLabel: "Club Coordinator's Name",
//   alternatePhoneNumberLabel: "Alternate Phone Number",
//   dealerPrincipalNameLabel: "Dealer Principal Name",
//   tabBranchElement: "Branch",
//   longitudeLabel: "Longitude",
//   tabDetailElement: "Details",
//   branchCodeLabel: "Branch Code",
//   addressLineOneLabel: "Address Line 1",
//   addressLineThreeLabel: "Address Line 3",
//   cityLabel: "City",
//   dealerNameLabel: "Dealer Name",
//   pinCodeLabel: "Pincode",
//   stateLabel: "State",
//   dynamicBranchNameLabel: "Name:",
//   emailLabel: "Email",
// },
// rideDetailElement: {
//   backButtonElement: "Back",
//   rideLevelElement: "Ride Duration",
//   tabJoinRideElement: "All Applicants",
//   rideDurationElement: "Ride Duration In Hours",
//   descriptionElement: "Description",
//   destinationLongElement: "Destination Longitude",
//   updateButtonElement: "Update",
//   campaignCodeElement: "Campaign Code",
//   rejectionReasonElement: "Rejection Reason",
//   startPointElement: "Start Point",
//   cityElement: "City",
//   rideNameElement: "Ride Name",
//   rideStartDateElement: "Ride Start Date",
//   countryElement: "Country",
//   rejectButtonElement: "Reject",
//   assemblingTimeElement: "Start Time",
//   lastDateOfRegistrationElement: "Last Date of Registration",
//   stateElement: "State",
//   disApproveButtonElement: "Reject",
//   destinationElement: "Destination",
//   terrainTypeElement: "Terrain Type",
//   destinationLatElement: "Destination Latitude",
//   difficultLevelElement: "Difficulty Level",
//   moderationStatusElement: "Moderation Status",
//   sourceLongElement: "Source Longitude",
//   tabDetailElement: "Detail",
//   rideStatusElement: "Ride Status",
//   sourceLatElement: "Source Latitude",
//   headingElement: "Ride Details",
//   distFromTOElement: "Distance",
//   RideEndDateElement: "Ride End Date",
//   addUserElement: "Add Participant",
//   approveButtonElement: "Approve",
//   rideCoordinatorNameElement: "Coordinator Name",
//   rideCoordinatorMobileElement: "Coordinator Mobile",
//   rideRegistrationFeeElement: "Registration Fee",
//   imageButtonElement: "Add Image"
// },
// memberShipListingTableElements: {
//   countryElement: "Country",
//   membershipElement: "Membership",
//   emailElement: "Email",
//   statusElement: "Status",
//   noRecordsFoundElement: "No records to display",
//   clusterValidationElement: "Cluster not found",
//   actionsElement: "Actions",
//   branchElement: "Branch",
//   phoneElement: "Phone",
//   nameElement: "Name",
//   sourceElement: "Source",
//   userTypeElement: "User type",
//   originDealerElement: "Origin Dealer",
// },
// headerElement: {
//   headingModelChangePassword: "Change Password",
//   submitButtonElement: "Update",
//   passwordValidationElement: "Password Didn't Match",
//   changePasswordDropDown: "Change Password",
//   newPasswordPlaceholder: "New Password",
//   newPasswordLabel: "New Password*",
//   confirmPasswordPlaceholder: "Confirm New Password",
//   confirmPasswordLabel: "Confirm New Password*",
//   oldPasswordLabel: "Old Password*",
//   logoutDropdown: "Logout",
//   oldPasswordPlaceholder: "Old Password",
//   englishLanguageElement: "English",
//   frenchLanguageElement: "French",
//   spanishLanguageElement: "Spanish",
//   italianLanguageElement: "Italian",
//   germanLanguageElement: "German",
//   dutchLanguageElement: "Dutch",
// },
// dealersListingFilterElements: {
//   searchButtonElement: "Search",
//   mobilePlaceholder: "Phone",
//   totalCountElement: "Total Count - ",
//   noRecordsFoundElement: "No records to display",
//   filterButtonElement: "Filter",
//   statusLabel: "Status",
//   mobileLabel: "Phone",
//   dealerIdPlaceholder: "Dealer Id",
//   emailPlaceholder: "Email",
//   headingElement: "Dealers",
//   dealerIdLabel: "Dealer Id",
//   clearFilterButtonElement: "Clear Filter(s)",
//   actionsElement: "Actions",
//   emailLabel: "Email",
//   CountryLabel: "All Countries",
//   selectStateLabel: "Select State",
//   selectCityLabel: "Select City",
// },
// branchListingFilterElements: {
//   branchIdLabel: "Branch Id",
//   branchIdPlaceholder: "Branch Id",
//   emailPlaceholder: "Email",
//   searchButtonElement: "Search",
//   headingElement: "Branches",
//   clearFilterButtonElement: "Clear Filter(s)",
//   mobilePlaceholder: "Phone",
//   totalCountElement: "Total Count - ",
//   filterButtonElement: "Filter",
//   emailLabel: "Email",
//   statusLabel: "Status",
//   mobileLabel: "Phone",
//   CountryLabel: "All Countries",
//   selectStateLabel: "Select State",
//   selectCityLabel: "Select City",
//   pendingElement: "Pending",
//   approvedElement: "Approved",
//   rejectedElement: "Rejected",
// },
// dealerListTableElement: {
//   countryElement: "Country",
//   emailElement: "Email",
//   dealerIdElement: "Dealer Id",
//   noRecordsFoundElement: "No records to display",
//   actionsElement: "Actions",
//   phoneElement: "Phone",
//   stateElement: "State",
//   cityElement: "City",
//   nameElement: "Name",
//   clubCoordinatorNameElement: "Club Coordinator's Name",
// },
// userMembershipListingFilterElements: {
//   searchButtonElement: "Search",
//   mobilePlaceholder: "Phone Number",
//   filterButtonElement: "Filter",
//   endDatePlaceHolderElement: "Select End Date",
//   statusLabel: "Status",
//   mobileLabel: "Phone Number",
//   emailValidationElement: "Email cannot be empty",
//   exportToExcelButton: "Export To Excel",
//   emailPlaceholder: "Email",
//   headingElement: "Riders Membership",
//   clearFilterButtonElement: "Clear Filter(s)",
//   exportToExcelEmailPlaceholder: "E-mail",
//   startDateLabelElement: "Start Date",
//   exportToExcelEmailLabel: "E-mail",
//   emailLabel: "Email",
//   endDateLabelElement: "End Date",
//   totalCountElement: "Total Count - ",
//   startDatePlaceHolderElement: "Select Start Date",
//   vinElement: "VIN",
// },
// branchListingTableElements: {
//   countryElement: "Country",
//   emailElement: "Email",
//   branchIdElement: "Branch Id",
//   noRecordsFoundElement: "No records to display",
//   moderationStatusElement: "Moderation Status",
//   actionsElement: "Actions",
//   phoneElement: "Phone",
//   stateElement: "State",
//   cityElement: "City",
//   nameElement: "Name",
//   clubCoordinatorNameElement: "Club Coordinator's Name",
// },
// preRegisterUserElements: {
//   consentsDoNotPhoneElement: "Do Not Phone",
//   startDateLabelElement: "Start Date",
//   endDateLabelElement: "End Date",
//   noRecordsFoundElement: "No records to display",
//   startDatePlaceHolderElement: "Select Start Date",
//   ownerElement: "Owner",
//   consentsAllPromotionsElement: "All Promotions",
//   emailValidationElement: "Email cannot be empty",
//   dateValidationElement: "Dates cannot be empty",
//   countryElement: "Country",
//   consentsPromotionsNewsElement: "Promotional News",
//   endDatePlaceHolderElement: "Select End Date",
//   nameElement: "Name",
//   searchButtonElement: "Search",
//   totalCountElement: "Total Count - ",
//   consentsSurveysAndResearchElement: "Survey and Research",
//   filterButtonElement: "Filter",
//   callingCodeElement: "Calling Code",
//   exportToExcelButtonElement: "Export To Excel",
//   consentsDoNotEmailElement: "Do Not Email",
//   emailPlaceholder: "Email",
//   headingElement: "Pre-Registrations",
//   emailElement: "Email",
//   clearFilterButtonElement: "Clear Filter",
//   consentsCommunityActivitiesElement: "Community Activities",
//   createdOnElement: "Created on",
//   actionsElement: "Actions",
//   emailLabel: "Email",
//   phoneElement: "Phone",
// },
// eventCreateElement: {
//   backButtonElement: "Back",
//   sourceLongLabelElement: "Event Longitude*",
//   registrationFeePlaceHolderElement: "Registration Fee",
//   eventLocationLabelElement: "Event Location*",
//   countryValidationElement: "Select Country",
//   cityElement: "City*",
//   sourceLatLabelElement: "Event Latitude*",
//   eventCoordinatorEmailLabelElement: "Event Coordinator's Email",
//   sourceLatPlaceHolderElement: "Event Latitude",
//   hospitalityElement: "Hospitality*",
//   placeAvailableLabelElement: "Places available*",
//   eventCoordinatorMobilePlaceHolderElement:
//     "Event Coordinator's Mobile Number",
//   eventDurationPlaceHolderElement: "Event Duration",
//   stateElement: "State*",
//   eventStartDateLabelElement: "Event Start Date*",
//   endDateValidationElement: "Select End Date",
//   eventDurationLabelElement: "Event Duration (In Hours)*",
//   eventCoordinatorEmailPlaceHolderElement: "Event Coordinator's Email",
//   testRideElement: "Test Rides*",
//   eventCoordinatorLabelElement: "Event Coordinator's Name",
//   cityPlaceHolderElement: "Enter City",
//   eventStartDatePlaceHolderElement: "Event Start Date",
//   startTimeValidationElement: "Select Start Time",
//   stateValidationElement: "Select State",
//   durationValidationElement: "Enter Duration",
//   cityLabel: "City*",
//   headingElement: "Create an Event",
//   stateLabel: "State*",
//   testRideValidationElement: "Select Test Rides",
//   hospitalityValidationElement: "Select Hospitality",
//   userMaxCountLabelElement: "Event Capacity*",
//   userMaxCountValidationElement: "Enter Event Capacity",
//   campaignCodeLabelElement: "Campaign Code",
//   eventDescriptionPlaceHolderElement: "Event Description",
//   locationValidationElement: "Select Location",
//   eventEndDateLabelElement: "Event End Date*",
//   campaignCodePlaceHolderElement: "Campaign Code",
//   placeAvailablePlaceHolderElement: "Places available",
//   eventNameValidationElement: "Enter Event Name",
//   cityValidationElement: "Select City",
//   advanceBookingElement: "Advanced Booking*",
//   userMaxCountPlaceHolderElement: "Enter Event Capacity",
//   registrationValidationElement: "Select Last date of registration",
//   countryElement: "Country*",
//   advanceBookingValidationElement: "Select Advanced Booking",
//   eventCoordinatorMobileLabelElement: "Event Coordinator's Mobile Number",
//   startDateValidationElement: "Select Start Date",
//   eventStartTimeLabelElement: "Event Start Time*",
//   userDataValidationElement: "User Data not Found",
//   eventStartTimePlaceHolderElement: "Event Start Time",
//   eventCoordinatorPlaceHolderElement: "Event Coordinator's Name",
//   lastDateOfRegPlaceHolderElement: "Last Date of Registration",
//   eventEndDatePlaceHolderElement: "Event End Date",
//   statePlaceHolderElement: "Enter State",
//   eventNameLabelElement: "Event Name*",
//   submitButtonElement: "Submit",
//   eventNamePlaceHolderElement: "Event Name",
//   registrationFeeLabelElement: "Registration Fee",
//   lastDateOfRegLabelElement: "Last Date of Registration*",
//   sourceLongPlaceHolderElement: "Event Longitude",
//   eventDescriptionLabelElement: "Event Description",
//   redirectionalUrl: "Redirection Url",
//   redirectionalUrlPlaceHolderElement:"Enter Link",
// },
// testimonialCreationElements: {
//   backButtonElement: "Back",
//   subHeadingElement: "Testimonial",
//   submitButtonElement: "Submit",
//   authorPlaceholder: "Author",
//   titleLabel: "Title*",
//   authorLabel: "Author*",
//   imageValidationElement:
//     "only '.jpg' , '.jpeg' , '.png' file types are accepted",
//   headingElement: "Testimonial Application",
//   branchIdValidationElement: "Branch Id not found",
//   descriptionPlaceholder: "Description",
//   titlePlaceholder: "Title",
//   descriptionLabel: "Description*",
// },
// userDetailsElements: {
//   addVehicleElement: "Add Vehicle",
//   subHeadingElement: "PERSONAL INFORMATION",
//   countryCodeLabel: "Country Code",
//   alreadyAMemberValidationElement: "Already Member",
//   clusterLabel: "Cluster",
//   headingElement: "User Detail",
//   mobileNumber: "Phone Number",
//   genderLabel: "Gender",
//   lNameLabel: "Last Name",
//   emailLabel: "Email ID",
//   dobLabel: "DOB",
//   fNameLabel: "First Name",
//   vechicleInformationLabel:"VEHICLE INFORMATION",
//   motorcyleNameLabel:"Motorcycle Name -",
//   motorcyleColorLabel:"Motorcycle Color -",
//   vinLabel:"VIN -",
//   registerationNumberLabel:"Registration Number -",
//   purchaseDateLabel:"Purchase Date -",
//   selectMotorcycleButtonElement:"Select Motorcycle",
//   noVechicleToShowLabel:"No Vehicles To Show",
//   becomeMemberLabel:"Become a Member"
// },
// userListingTableElements: {
//   regionElement: "Region",
//   "actionsElement ": "Actions",
//   emailElement: "Email",
//   noRecordsFoundElement: "No records to display",
//   dateOfBirthElement: "DOB",
//   phoneElement: "Phone",
//   nameElement: "Name",
//   registrationElement: "Registration",
// },
// eventListTableElement: {
//   statusLabelElement: "Status",
//   eventNameElement: "Event Name",
//   eventLocationElement: "Event Location",
//   headingElement: "Event",
//   campaignCodeElement: "Campaign Code",
//   statsElement: "State",
//   noRecordsFoundElement: "No records to display",
//   moderationStatusElement: "Moderation Status",
//   actionsElement: "Actions",
//   cityElement: "City",
//   branchNameElement: "Branch Name",
//   countryNameElement: "Country Name",
//   pendingElement: "Pending",
//   approvedElement: "Approved",
//   rejectedElement: "Rejected",
// },
// riderRegistrationElements: {
//   countryCodeLabel: "Calling Code",
//   genderLabel: "Gender",
//   subHeadingVehicleElement: "Vehicle Details",
//   clusterValidationElement: "Cluster not found",
//   subHeadingRiderElement: "Rider Details",
//   fNameLabel: "First Name",
//   mobileLabel: "Mobile Number",
//   variantLabel: "Variant",
//   submitButtonElement: "Register",
//   motorCycleLabel: "Motorcycle",
//   vinLabel: "VIN",
//   headingElement: "User Registration",
//   lNameLabel: "Last Name",
//   registrationNumberLabel: "Registration Number",
//   dobLabel: "Date of Birth",
//   emailLabel: "Email Id",
//   dateOfPurchaseLabel: "Date Of Purchase",
// },
// imageModerationListingFilterElements: {
//   headingElement: "Image Moderation",
//   filterButtonElement: "Filter",
//   categoryLabelElement: "Category",
//   countryLabelElement: "Country",
//   selectCountryLabelElement: "Select Country",
//   branchLabelElement: "Branch",
//   selectBranchLabelElement: "Select Branch",
//   statusLabelElement: "Status",
//   activityLabelElement: "Activity",
//   selectActivityLabelElement: "Select Activity",
//   searchButtonElement: "Search",
//   clearFilterButtonElement: "Clear Filter",
//   approveAllElement: "Approve All",
//   rejectAllElement: "Reject All",
//   approveElement: "Approve",
//   rejectElement: "Reject",
//   deleteElement: "Delete",
//   previewLabelElement: "Preview",
//   hastagElement: "Hashtag",
//   descriptionElement: "Description",
//   activityNameElement: "Activity Name",
//   countryElement: "Country",
//   stateElement: "State",
//   nameElement: "Name",
//   emailElement: "Email",
//   selectRideElement: "Ride",
//   selectEventElement: "Event",
//   pendingElement: "Pending",
//   approvedElement: "Approved",
//   rejectedElement: "Rejected",
//   branchNameElement: "Branch Name",
//   branchCodeElement: "Branch Code",
//   updatedOnElement: "Updated On",
//   noImagesToShowElement: "No Images To Show."
// },
// reviewListTableElement: {
//   headingElement: "Review",
//   filterButtonElement: "Filter",
//   categoryLabelElement: "Category",
//   countryLabelElement: "Country",
//   selectCountryElement: "Select Country",
//   branchLabelElement: "Branch",
//   selectBranchLabelElement: "Select Branch",
//   activityLabelElement: "Activity",
//   selectActivityLabelElement: "Select Activity",
//   searchButtonElement: "Search",
//   clearFilterButtonElement: "Clear Filter",
//   nameElement: "Name",
//   emailElement: "Email",
//   mobileElement: "Mobile",
//   activityTypeElement: "Activity Type",
//   activityNameElement: "Activity name",
//   experienceElement: "Experience",
//   interestElement: "Interest",
//   organisationElement: "Organisation",
//   overallElement: "Overall",
//   descriptionElement: "Description",
//   noRecordsFoundElement: "No records to display",
//   actionsElement: "Actions",
//   selectRideElement: "Ride",
//   selectEventElement: "Event",
//  },
// statusElement: {
//   pendingElement: "Pending",
//   approvedElement: "Approved",
//   rejectedElement: "Rejected",
//   unallocatedElement: "Unallocated",
//   launchedElement: "Launched",
//   upcomingElement: "Upcoming",
//   proposedElement: "Proposed",
//   cancelledElement: "Cancelled",
//   suspendedElement: "Suspended",
//   easyElement: "Easy",
//   mediumElement: "Medium",
//   difficultElement: "Difficult",
//   joinedElement: "Joined",
//   completedElement: "Completed",
//   ongoingElement: "Ongoing",
//   nAElement: "N/A",
// }

//customMaterialTableElement: {
// labelRowsSelect: "rows",
//  previousTooltip: "previous",
//     nextTooltip: "next",
//}

//bookingCardElement: {
// totalBookingElement: "Total Booking"
// overallBookingElement: "Overall Booking Growth"
// pendingRequestElement: "Pending request"
// recievedThisWeekElement: "Recieved this week"
// pendingPaymentElement: "Pending Payment"
// overdueElement: "Overdue"
// totalRevenueElement: "Total Revenue"
// }

// landingPageElement: {
// headingElement: "Riders Club Europe - Dashboard",
// filterButtonElement: "Filter",
// totalCountElement: "Total Count - ",
// selectCountryLabelElement: "Select Country",
// countryLabel: "All Countries",
// startDateLabelElement: "Start Date",
// startDatePlaceHolderElement: "Select Start Date",
// endDateLabelElement: "End Date",
// endDatePlaceHolderElement: "Select End Date",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// exportToExcelButtonElement: "Export To Excel",
// branchesElement: "Branches",
// customersElement: "Customers",
// membersElement: "Members",
// eventsElement: "Events",
// ridesElement: "Rides",
// approvedPieElement: "Approved",
// rejectedPieElement: "Rejected",
// pendingPieElement: "Pending",
// dashboardPieElement: "Dashboard",
// websitePieElement: "Website",
// appPieElement: "App",
// unallocatedPieElement: "Unallocated" ,
// nonMemberCustomersElement: "Non-Members (Customers)",
// }

// memberListingElement: {
// headingElement: "Members",
// filterButtonElement: "Filter",
// totalCountElement: "Total Count - ",
// selectCountryLabelElement: "Select Country",
// countryLabel: "All Countries",
// startDateLabelElement: "Start Date",
// startDatePlaceHolderElement: "Select Start Date",
// endDateLabelElement: "End Date",
// endDatePlaceHolderElement: "Select End Date",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// exportToExcelButtonElement: "Export To Excel",
// nameElement: "Name",
// callingCodeElement: "Calling Code",
// phoneElement: "Phone",
// emailElement: "Email",
// countryElement: "Country",
// sourceElement: "Source",
// createdOnElement: "Created on",
// noRecordsFoundElement: "No records to display",
// actionsElement: "Actions",
// }

// memberListingDetailPanelElement : {
// branchCodeElement: "Branch Code",
// branchNameElement: "Branch name",
// dobElement: "DOB",
// membershipCategoryElement: "MemberShip Category",
// moderationStatusElement: "Moderation Status",
// vehicleModelCodeElement: "Vehicle Model Code",
// vehicleModelColorElement: "Vehicle Model Color",
// vehicleModelNameElement: "Vehicle Model name",
// consentsAllPromotionsElement: "All Promotions",
// consentsCommunityActivitiesElement: "Community Activities",
// consentsDoNotEmailElement: "Email",
// consentsDoNotPhoneElement: "Phone",
// consentsPromotionsNewsElement: "Promotional News",
// consentsSurveysAndResearchElement: "Survey and Research",
// noUserFoundElement: "No user found"
// }

// nonmemberListingElement: {
// headingElement: "Non-Member",
// filterButtonElement: "Filter",
// totalCountElement: "Total Count - ",
// selectCountryLabelElement: "Select Country",
// countryLabel: "All Countries",
// startDateLabelElement: "Start Date",
// startDatePlaceHolderElement: "Select Start Date",
// endDateLabelElement: "End Date",
// endDatePlaceHolderElement: "Select End Date",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// exportToExcelButtonElement: "Export To Excel",
// nameElement: "Name",
// phoneElement: "Phone",
// emailElement: "Email",
// countryElement: "Country",
// sourceElement: "Source",
// createdOnElement: "Created on",
// noRecordsFoundElement: "No records to display",
// actionsElement: "Actions",
// emailValidationElement: "Email cannot be empty",
// }

// nonMemberDetailElement: {
// dobElement: "DOB",
// userTypeElement: "User Type",
// vehicleModelCode: "Vehicle Model Code",
// vehicleModelColor: "Vehicle Model Color",
// vehicleModelName: "Vehicle Model name",
// consentsAllPromotionsElement: "All Promotions",
// consentsCommunityActivitiesElement: "Community Activities",
// consentsDoNotEmailElement: "Email",
// consentsDoNotPhoneElement: "Phone",
// consentsPromotionsNewsElement: "Promotional News",
// consentsSurveysAndResearchElement: "Survey and Research",
// noUserFoundElement: "No user found"
// }

// operatorCardElement:{
// numberOfOperatorElement: "Number of Operators",
// withOwnFleetElement: "With own fleet",
// withoutOwnFleetElement: "Without own fleet",
// numberOfCustumersElement: "Number of Custumerss",
// completedTripElement: "Completed Trip",
// inquiriesReceivedElement: "Inquiries Received",
// }

// vinLookupElement: {
// headingElement: "VIN Lookup",
// filterButtonElement: "Filter",
// labelElement: "VIN",
// vinPlaceholder: "Enter VIN",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// nameElement: "Name",
// modelNameElement: "ModelName",
// vinElement: "VIN",
// noRecordsFoundElement: "No records to display",
// actionsElement: "Actions",
// confirmationTextElement: "Confirmation",
// ownershipConfirmationTextElement: "Are you sure you want to transfer the ownership of the vehicle",
// fromTextElement: "from",
// toTextElement: "to",
// confirmButtonElement: "Confirm",
// validEmailValidationElement: "Enter Valid Email",
// emailElement: "Email",
// mobileElement: "Mobile",
// purchaseDateElement: "Purchase Date",
// registrationNoElement: "Registration No",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// searchUserButtonElement: "Search User",
// firstnNameElement: "First name",
// lastNameElement: "Last name",
// phoneElement: "Phone",
// transferOwnershipButtonElement: "Transfer Ownership",
// transferEmailLabel: "Transfer of Ownership: Enter Email ID",
// noUserFoundElement: "No user found",
// uploadErrorElement: "Can not Upload more than 3 Files",
// }

// vinModerationListingElements: {
// filterButtonElement: "Filter",
// totalCountElement: "Total Count -",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// mobileLabel: "Phone Number",
// mobilePlaceholder: "Phone Number",
// statusLabel: "Status",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// exportToExcelEmailLabel: "Email",
// exportToExcelEmailPlaceholder: "Email",
// modelNameLabel: "Model Name",
// vinLabel: "VIN",
// createdAtLabel: "Created At (GMT)",
// updatedAtLabel: "Updated At (GMT)",
// noRecordsFoundElement: "No records to display",
// actionsElement: "Actions",
// detailPageTooltipElement: "Detail Page",
// }

// vinModerationDetailElement: {
// vinDetailHeadingElement: "VIN Details",
// subHeadingUserElement: "User Details",
// emailLabel: "Email Id",
// modelNameLabel: "Model Name",
// phoneLabel: "Phone",
// vinLabel: "VIN",
// createdAtLabel: "CreatedAt",
// updatedAtLabel: "UpdatedAt",
// modelCodeLabel: "Model Code",
// modelColorLabel: "Model Color",
// registrationNumberLabel: "Registration Number",
// backButtonElement: "Back",
// rejectButtonElement: "Reject",
// approveButtonElement: "Approve",
// confirmationLabel: "Confirmation",
// validationElement: "Are you sure you want to",
// confirmButtonElement: "Confirm",
// currentOwnerEmailLabel: "Current Owner Email Id",
// newOwnerEmailLabel: "New Owner Email Id",
// }

// ridesReportsListingElement: {
// headingElement: "Rides",
// filterButtonElement: "Filter",
// totalCountElement: "Total Count - ",
// selectCountryLabelElement: "Select Country",
// countryLabel: "All Countries",
// startDateLabelElement: "Start Date",
// startDatePlaceHolderElement: "Select Start Date",
// endDateLabelElement: "End Date",
// endDatePlaceHolderElement: "Select End Date",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// exportToExcelButtonElement: "Export To Excel",
// rideNameElement: "Ride Name",
// rideCountryElement: "Ride Country",
// rideStateElement: "Ride State",
// rideCityElement: "Ride City",
// branchNameElement: "Branch Name",
// branchCodeElement: "Branch Code",
// noRecordsFoundElement: "No records to display",
// actionsElement: "Actions",
// emailValidationElement: "Email cannot be empty",
// moderationStatusElement: "Moderation Status"
// }

//ridesReportsDetailElement: {
// branchNameElement: "Branch Name",
// branchCodeElement: "Branch Code",
// rideCountryElement: "Ride Country",
// rideStateElement: "Ride State",
// rideCityElement: "Ride City",
// moderationStatusElement: "Moderation Status",
// rideStartDateElement: "Ride Start Date",
// rideEndDateElement: "Ride End Date",
// rideStatusElement: "Ride Status",
// rideLevelElement: "Ride Level",
// allocatedRideCountElement: "Allocated Ride Count",
// noUserFoundElement: "No user found",
// }

// branchReportsListingElement: {
// headingElement: "Branch",
// filterButtonElement: "Filter",
// totalCountElement: "Total Count - ",
// selectCountryLabelElement: "Select Country",
// countryLabel: "All Countries",
// startDateLabelElement: "Start Date",
// startDatePlaceHolderElement: "Select Start Date",
// endDateLabelElement: "End Date",
// endDatePlaceHolderElement: "Select End Date",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// exportToExcelButtonElement: "Export To Excel",
// branchCountryElement: "Branch Country",
// branchStateElement: "Branch State",
// branchCityElement: "Branch City",
// branchNameElement: "Branch Name",
// branchCodeElement: "Branch Code",
// noRecordsFoundElement: "No records to display",
// actionsElement: "Actions",
// emailValidationElement: "Email cannot be empty",
// }

// branchReportsDetailListingElement: {
// branchNameElement: "Branch Name",
// branchCodeElement: "Branch Code",
// branchCountryElement: "Branch Country",
// branchStateElement: "Branch State",
// branchCityElement: "Branch City",
// branchIdElement: "Branch Id",
// branchStatusElement: "Branch Status",
// noUserFoundElement: "No user found",
// }

// eventsReportsListingElement: {
// headingElement: "Events",
// filterButtonElement: "Filter",
// totalCountElement: "Total Count - ",
// selectCountryLabelElement: "Select Country",
// countryLabel: "All Countries",
// startDateLabelElement: "Start Date",
// startDatePlaceHolderElement: "Select Start Date",
// endDateLabelElement: "End Date",
// endDatePlaceHolderElement: "Select End Date",
// searchButtonElement: "Search",
// clearFilterButtonElement: "Clear Filter",
// emailLabel: "Email",
// emailPlaceholder: "Email",
// exportToExcelButtonElement: "Export To Excel",
// eventNameElement: "Event Name",
// eventCountryElement: "Event Country",
// eventStateElement: "Event State",
// eventCityElement: "Event City",
// branchNameElement: "Branch Name",
// branchCodeElement: "Branch Code",
// noRecordsFoundElement: "No records to display",
// actionsElement: "Actions",
// emailValidationElement: "Email cannot be empty",
// moderationStatusElement: "Moderation Status"
// }

//eventsReportsDetailElement: {
// eventNameElement: "Event Name",
// eventCountryElement: "Event Country",
// eventStateElement: "Event State",
// eventCityElement: "Event City",
// eventLocationElement: "Event Location",
// branchNameElement: "Branch Name",
// branchCodeElement: "Branch Code",
// eventStartDateElement: "Event Start Date",
// eventEndDateElement: "Event End Date",
// eventStatusElement: "Event Status",
// moderationStatusElement: "Moderation Status",
// eventDescriptionElement: "Event Description",
// allocatedRideCountElement: "Allocated Ride Count",
// noUserFoundElement: "No user found",
// }

// {
//   euToursElement: {
//     addNewTourElement: {
//       addNewTourHeadingElement: "Add New Tour",
//       addNewTourSubHeadingElement: "Tour Details",
//       addNewTourNameElement: "Name",
//       addNewTourNamePlaceholderElement: "Name",
//       startLocationElement: "Start Location",
//       startLocationLatitudeElement: "Start Location Latitude",
//       startLocationLatitudePlaceholderElement:
//         "Start Location Latitude",
//       startLocationLongitudeElement: "Start Location Longitude",
//       startLocationLongitudePlaceholderElement:
//         "Start Location Longitude",
//       endLocationElement: "end Location",
//       endLocationLatitudeElement: "end Location Latitude",
//       endLocationLatitudePlaceholderElement: "end Location Latitude",
//       endLocationLongitudeElement: "end Location Longitude",
//       endLocationLongitudePlaceholderElement: "end Location Longitude",
//       startDateElement: "Start Date",
//       startDatePlaceholderElement: "Start Date",
//       endDateElement: "End Date",
//       endDatePlaceholderElement: "End Date",
//       distanceCoveredLabelElement: "Estimated Distance Covered (KM)",
//       distanceCoveredPlaceholderElement: "Estimated Distance Covered",
//       redirectionalUrlLabelElement: "Redirection-Url",
//       redirectionUrlPlaceholderElement: "https://www.example.com",
//       regionLabelElement: "Region",
//       regionPlaceholerElement: "Select Region",
//       countryLabelElemnt: "Country",
//       countryPlaceholderElement: "Select Country",
//       descriptionLabelElement: "Description",
//       UploadMediaSubHeadingElement: "Upload Media",
//       thumbnailImageLabelElement:
//         "Tour Landing Page - Thumbnail - Common (160 x 190 px)",
//       thumbnailImagePlaceholderElement:
//         "Tour Landing Page - Thumbnail - Common (160 x 190 px)",
//       thumnailImageFormatElement:
//         "Format: JPG PNG JPEG WEBP. Max Size: 1MB.",
//       partnerImagesLabelElement:
//         "Partner Detail Page - Tour Listing Thumbnail - Common (360 x 310 px)",
//       galleryImagesLabelElement: "Gallery Images Common",
//       galleryImageFormatElement:
//         "Max 20 images allowed. Format: JPG JPEG WEBP PNG. Max Size: 1MB.",
//       backButtonElement: "Back",
//       submitButtonElement: "Submit",
//       previewButtonElement: "Preview",
//       searchPlacesElement: "Search Places ...",
//       thumbnailImageUploadValidation:
//         "Only 1 image is allowed to upload",
//       imageUploadvalidation: "Max 20 images are allowed to be upload",
//       galleryImageSizeValidationElement:
//         "The size of the image should be less than 1 mb",
//       galleryImageDimensionValidationElement:
//         "Image dimensions must be equal to",
//       galleryImageDimensionAndSizeValidationElement:
//         "The size of the image should be less than 1 mb & Image dimensions must be equal to",
//       imagesLengthElement: "Only 1 image is allowed to upload",
//       enterExpNameValidation: "Please enter tour name",
//       enterExpStartLocationValidation:
//         "Please enter tour start location",
//       enterExpEndLocationValidation: "Please enter tour end location",
//       enterExpStartDateValidation: "Please select tour start date",
//       enterExpEndDateValidation: "Please select tour End date",
//       enterRedirectionUrlValidation: "Please enter redirection url",
//       selectRegionValidation: "Please select region",
//       selectCountryValidation: "Please select country",
//       enterDescriptionValidation:
//         "Please enter short description for the tour",
//       uploadThumbnailImageValidation:
//         "Please upload the thumbnail for tour landing filter",
//       thumbnailPartnerImageValidation:
//         "Please upload the thumbnail for tour listing on partner detail page",
//       uploadgalleryImageOfExpValidation:
//         "Please upload gallery images of the tour",
//     },
//     addNewExpierenceElement: {
//       addNewExpierenceHeadingElement: "Add New Experiences",
//       addNewExpierenceSubHeadingElement: "Experience Detail",
//       addNewExpierenceNameElement: "Name",
//       addNewExpierenceNamePlaceholderElement: "Name",
//       startLocationElement: "Start Location",
//       startLocationLatitudeElement: "Start Location Latitude",
//       startLocationLatitudePlaceholderElement:
//         "Start Location Latitude",
//       startLocationLongitudeElement: "Start Location Longitude",
//       startLocationLongitudePlaceholderElement:
//         "Start Location Longitude",
//       endLocationElement: "end Location",
//       endLocationLatitudeElement: "end Location Latitude",
//       endLocationLatitudePlaceholderElement: "end Location Latitude",
//       endLocationLongitudeElement: "end Location Longitude",
//       endLocationLongitudePlaceholderElement: "end Location Longitude",
//       startDateElement: "Start Date",
//       startDatePlaceholderElement: "Start Date",
//       endDateElement: "End Date",
//       endDatePlaceholderElement: "End Date",
//       distanceCoveredLabelElement: "Estimated Distance Covered (KM)",
//       distanceCoveredPlaceholderElement: "Estimated Distance Covered",
//       redirectionalUrlLabelElement: "Redirection-Url",
//       redirectionUrlPlaceholderElement: "https://www.example.com",
//       regionLabelElement: "Region",
//       regionPlaceholerElement: "Select Region",
//       countryLabelElemnt: "Country",
//       countryPlaceholderElement: "Select Country",
//       descriptionLabelElement: "Description",
//       UploadMediaSubHeadingElement: "Upload Media",
//       thumbnailImageLabelElement:
//         "Experience Landing Page - Thumbnail -  Common (160 x 190 px)",
//       thumbnailImagePlaceholderElement:
//         "Experience Landing Page - Thumbnail -  Common (160 x 190 px)",
//       thumnailImageFormatElement:
//         "Format: JPG PNG JPEG WEBP. Max Size: 1MB.",
//       partnerDetailPageImageElement:
//         "Partner Detail Page - Experience Listing Thumbnail - Common (360 x 310 px)",
//       galleryImagesElement: "Gallery Images Common",
//       galleryImageFormatElement:
//         "Max 20 images allowed. Format: JPG JPEG WEBP PNG. Max Size: 1MB.",
//       backButtonElement: "Back",
//       submitButtonElement: "Submit",
//       previewButtonElement : "Preview",
//       searchPlacesElement: "Search Places ...",
//       galleryMaxUploadValidation:
//         "Max 20 images are allowed to be upload",
//       directionRequestFailedDueToValidation:
//         "Directions request failed due to ",
//       directionRequestFailedValidation: "Directions request failed",
//       enterExpNameValidation: "Please enter experience name",
//       enterExpStartLocationValidation:
//         "Please enter experience start location",
//       enterExpEndLocationValidation:
//         "Please enter experience end location",
//       enterExpStartDateValidation:
//         "Please select experience start date",
//       enterExpEndDateValidation: "Please select experience End date",
//       enterRedirectionUrlValidation: "Please enter redirection url",
//       selectRegionValidation: "Please select region",
//       selectCountryValidation: "Please select country",
//       enterDescriptionValidation:
//         "Please enter short description for the experience",
//       uploadThumbnailImageValidation:
//         "Please upload the thumbnail for experience landing filter",
//       thumbnailPartnerImageValidation:
//         "Please upload the thumbnail for experience listing on partner detail page",
//       uploadgalleryImageOfExpValidation:
//         "Please upload gallery images of the experience",
//       imagesLengthElement: "Only 1 image is allowed to upload",
//       galleryImageSizeValidationElement:
//         "The size of the image should be less than 1 mb",
//       galleryImageDimensionValidationElement:
//         "Image dimensions must be equal to",
//       galleryImageDimensionAndSizeValidationElement:
//         "The size of the image should be less than 1 mb & Image dimensions must be equal to",
//     },
//     partnerLandingPage: {
//       welcomeText: "Welcome",
//       filterButtonElement: "Filter",
//       selectCategoryElement: "Select Category",
//       selectCategoryPlaceholderElement: "Select Category",
//       tourCategoryOptionElement: "Tours",
//       experienceCategoryOptionElement: "Experience",
//       selectCountryElement: "Select Country",
//       countryLabel: "All Countries",
//       startDateLabelElement: "Start Date",
//       startDatePlaceHolderElement: "Select Start Date",
//       endDateLabelElement: "End Date",
//       endDatePlaceHolderElement: "Select End Date",
//       searchButtonElement: "Search",
//       clearFilterButtonElement: "Clear Filter",
//       latestToursElement: "Tours",
//       viewDetailButtonElement: "View detail",
//       nameLabel: "Name",
//       descriptionLabel: "Description",
//       statusLabel: "Status",
//       actionLabel: "Action",
//       noDataToShowElement: "No data to show",
//       latestExperienceElement: "Experiences",
//       recentTestimonialsElement: "Testimonials",
//     },
//     addNewTestimonials: {
//       addNewTestimonialHeadingElement: "Add New Testimonial",
//       riderNameElement: "Rider Name",
//       riderLocationElement: "Rider Location",
//       postedDateElement: "Posted Date",
//       riderNoteElement: "Rider Note",
//       riderImageElement: "Rider Image/Default image (80 x 80 px)",
//       riderImageFormatElement:
//         "Format: JPG PNG JPEG WEBP. Max Size: 1MB.",
//       backButtonElement: "Back",
//       submitButtonElement: "Submit",
//       riderNameValidationElement: "Please enter rider name",
//       riderLocationValidationElement: "Please select rider location",
//       postedDateValidationElement: "Please select posted date",
//       riderNoteValidationElement: "Please enter rider note",
//       uploadImageValidationElement: "Please upload image",
//       galleryMinUploadValidation: "Only 1 image is allowed to upload",
//     },
//     AdminLandingPage: {
//       welcomeText: "Welcome",
//       filterButtonElement: "Filter",
//       selectCategoryElement: "Select Category",
//       selectCategoryPlaceholderElement: "Select Category",
//       tourCategoryOptionElement: "Tours",
//       experienceCategoryOptionElement: "Experience",
//       selectCountryElement: "Select Country",
//       countryLabel: "All Countries",
//       startDateLabelElement: "Start Date",
//       startDatePlaceHolderElement: "Select Start Date",
//       endDateLabelElement: "End Date",
//       endDatePlaceHolderElement: "Select End Date",
//       searchButtonElement: "Search",
//       clearFilterButtonElement: "Clear Filter",
//       pendingTourApprovalElement: "Tours",
//       pendingExperienceApproval: "Experiences",
//       nameLabel: "Name",
//       partnerNameLabel: "Partner Name",
//       statusLabel: "Status",
//       actionLabel: "Action",
//       viewDetailButtonElement: "View detail",
//       noDataToShowElement: "No data to show",
//       partnerElement: "Partners",
//       pendingTestimonialsElement: "Testimonials",
//       addPartnerElement: "Add Partner",
//       viewPendingRequestElement: "View Pending Request",
//     },
//     experiencePersonalInfo: {
//       partnerDeatilHeadingElement: "Partner Detail",
//       nameLabel: "Name",
//       emailLabel: "Email",
//       experienceDetailHeadingElement: "Experience Detail",
//       startLocationLabel: "Start Location",
//       startLocationLatitudeLabel: "Start Location Latitude",
//       startLocationLongitudeLabel: "Start Location Longitude",
//       endLocationLabel: "End Location",
//       endLocationLatitude: "End Location Latitude",
//       endLocationLongitude: "End Location Longitude",
//       startDateLabel: "Start Date",
//       endDateLabel: "End Date",
//       regionLabel: "Region",
//       countryLabel: "Country",
//       distanceCoveredLabel: "Estimated Distance Covered (KM)",
//       descriptionLabel: "Description",
//       thumbnailImageLabel:
//         "Thumbnail - Experience Landing - Common - (160 x 190 px) (Tap on the image to preview )",
//       galleryImageLabel:
//         "Gallery Images Desktop (Tap on the image to preview )",
//       rejectAllLabel: "Reject All",
//       acceptAllLabel: "Accept All Images",
//       rejectionReasonLabel: "Rejection Reason",
//       backLabel: "Back",
//       rejectLabel: "Reject",
//       approveLabel: "Approve",
//     },
//     toursPersonalInfo: {
//       partnerDeatilHeadingElement: "Partner Detail",
//       nameLabel: "Name",
//       emailLabel: "Email",
//       tourDetailHeadingElement: "Tour Detail",
//       startLocationLabel: "Start Location",
//       startLocationLatitudeLabel: "Start Location Latitude",
//       startLocationLongitudeLabel: "Start Location Longitude",
//       endLocationLabel: "End Location",
//       endLocationLatitude: "End Location Latitude",
//       endLocationLongitude: "End Location Longitude",
//       startDateLabel: "Start Date",
//       endDateLabel: "End Date",
//       regionLabel: "Region",
//       countryLabel: "Country",
//       distanceCoveredLabel: "Estimated Distance Covered (KM)",
//       descriptionLabel: "Description",
//       mediaTitle: "Media",
//       thumbnailImageLabel:
//         "Thumbnail - Tour Landing - Common - (160 x 190 px)(Tap on the image to preview )",
//       thumbnailImageDetailPageLabel:
//         "Partner Detail Page - Tour Listing Thumbnail - Common (360 x 310 px)(Tap on the image to preview )",
//       galleryImageLabel:
//         "Gallery Images Common (Tap on the image to preview )",
//       rejectionReasonTitle: " Rejection Reason",
//       rejectAllLabel: "Reject All",
//       acceptAllLabel: "Accept All Images",
//       rejectionReasonLabel: "Rejection Reason",
//       backLabel: "Back",
//       rejectLabel: "Reject",
//       approveLabel: "Approve",
//     },
//     toursPersonalPreviewInfo: {
//       partnerDeatilHeadingElement: "Partner Detail",
//       nameLabel: "Name",
//       emailLabel: "Email",
//       tourDetailHeadingElement: "Tour Detail",
//       startLocationLabel: "Start Location",
//       startLocationLatitudeLabel: "Start Location Latitude",
//       startLocationLongitudeLabel: "Start Location Longitude",
//       endLocationLabel: "End Location",
//       endLocationLatitude: "End Location Latitude",
//       endLocationLongitude: "End Location Longitude",
//       startDateLabel: "Start Date",
//       endDateLabel: "End Date",
//       regionLabel: "Region",
//       countryLabel: "Country",
//       distanceCoveredLabel: "Estimated Distance Covered (KM)",
//       descriptionLabel: "Description",
//       mediaTitle: "Media",
//       thumbnailImageLabel:
//         "T Landing Page - Thumbnail - Common (160 x 190 px)",
//       thumbnailImageDetailPageLabel:
//         "Partner Detail Page - Tour Listing Thumbnail - Common (360 x 310 px)",
//       galleryImageLabel: "Gallery Images Common",
//       backLabel: "Back",
//     },
//     experiencePersonalPreviewInfo: {
//       partnerDeatilHeadingElement: "Partner Detail",
//       nameLabel: "Name",
//       emailLabel: "Email",
//       tourDetailHeadingElement: "Experience Detail",
//       startLocationLabel: "Start Location",
//       startLocationLatitudeLabel: "Start Location Latitude",
//       startLocationLongitudeLabel: "Start Location Longitude",
//       endLocationLabel: "End Location",
//       endLocationLatitude: "End Location Latitude",
//       endLocationLongitude: "End Location Longitude",
//       startDateLabel: "Start Date",
//       endDateLabel: "End Date",
//       regionLabel: "Region",
//       countryLabel: "Country",
//       distanceCoveredLabel: "Estimated Distance Covered (KM)",
//       descriptionLabel: "Description",
//       mediaTitle: "Media",
//       thumbnailImageLabel:
//         "Experience Landing Page - Thumbnail - Common (160 x 190 px)",
//       thumbnailImageDetailPageLabel:
//         "Partner Detail Page - Experience Listing Thumbnail - Common (360 x 310 px)",
//       galleryImageLabel: "Gallery Images Common",
//       backLabel: "Back",
//     },
//     testimonialPersonalInfo: {
//       testimonialPersonalInfoHeadingElement: "Partner Detail",
//       nameLabel: "Name",
//       emailLabel: "Email",
//       testimonialDetailHeadingElement: "Testimonial Detail",
//       riderNameLabel: "Rider Name",
//       riderLocationLabel: "Rider Location",
//       postedDateLabel: "Posted Date",
//       riderNoteLabel: "Rider Note",
//       mediaHeading: "Media",
//       thumbnailImageHeading: "Rider Image/Default image (80 x 80 px)",
//       rejectLabel: "Reject",
//       acceptAllLabel: "Accept All Images",
//       rejectionReasonHeading: "Rejection Reason",
//       approveLabel: "Approve",
//       backLabel: "Back",
//       rejectAllLabel: "Reject All",
//     },
//     EuCustomMaterialTableElement: {
//       labelRowsSelect: "rows",
//       previousTooltip: "previous",
//       nextTooltip: "next",
//     },
//     tourListingElements: {
//       headingElement: "Tours",
//       filterButtonElement: "Filter",
//       totalCountElement: "Total Count -",
//       addNewElement: "Add New",
//       countryLabelElement: "Country",
//       selectCountryElement: "Select Country",
//       startDateElement: "Start Date",
//       endDateElement: "End Date",
//       searchButtonElement: "Search",
//       clearFilterButtonElement: "Clear Filter",
//       statusLabelElement: "Status",
//       pendingElement: "Pending",
//       approvedElement: "Approved",
//       rejectedElement: "Rejected",
//        modifiedElement: "Modified",
//       partnerNameElement: "Partner",
//       emailElement: "Email",
//       tourNameElement: "Tour Name",
//       startLocationElement: "Start Location",
//       endLocationElement: "End Location",
//       nameElement: "Name",
//       descriptionElement: "Description",
//       noRecordsFoundElement: "No records to display",
//       actionsElement: "Actions",
//       rejectionModelLabel: "Rejection Reason",
//       rejectModelButtonElement: "Reject",
//     },
//     experienceListingElements: {
//       headingElement: "Experiences",
//       filterButtonElement: "Filter",
//       totalCountElement: "Total Count -",
//       addNewElement: "Add New",
//       countryLabelElement: "Country",
//       selectCountryElement: "Select Country",
//       startDateElement: "Start Date",
//       endDateElement: "End Date",
//       searchButtonElement: "Search",
//       clearFilterButtonElement: "Clear Filter",
//       statusLabelElement: "Status",
//       pendingElement: "Pending",
//       approvedElement: "Approved",
//       rejectedElement: "Rejected",
//       modifiedElement: "Modified",
//       nameElement: "Name",
//       riderNoteElement: "Rider Note",
//       startLocationElement: "Start Location",
//       endLocationElement: "End Location",
//       noRecordsFoundElement: "No records to display",
//       actionsElement: "Actions",
//       rejectionModelLabel: "Rejection Reason",
//       rejectModelButtonElement: "Reject",
//     },
//     testimonialList: {
//       headingElement: "Testimonials",
//       filterButtonElement: "Filter",
//       totalCountElement: "Total Count - ",
//       addNewElement: "Add New",
//       countryHeadingElement: "Country",
//       selectCountryElementt: "Select Country",
//       emailElement: "Email",
//       emailPlaceholder: "Email",
//       phoneElement: "Phone",
//       phonePlaceholder: "Phone",
//       searchButtonElement: "Search",
//       clearFilterButtonElement: "Clear Filter",
//       statusLabelElement: "Status",
//       pendingElement: "Pending",
//       approvedElement: "Approved",
//       rejectedElement: "Rejected",
//       modifiedElement: "Modified",
//       partnerNameElement: "Partner",
//       riderNameElement: "Rider Name",
//       riderLocationElement: "Rider Location",
//       postedDateElement: "Posted Date",
//       noRecordsFoundElement: "No records to display",
//       actionsElement: "Actions",
//       riderImageElement: "Rider Image",
//       clubCoordinatorNameElement: "Rider Note",
//       riderNoteElement: "Rider Note",
//       rejectionModelLabel: "Rejection Reason",
//       rejectModelButtonElement: "Reject",
//     },
//     partnerPersonalPreviewInfoElement: {
//       headingElement: "Partner Personal Information",
//       businessNameElement: "Business Name",
//       shortBioElement: "Short Bio (Profile) of your Business",
//       emailElement: "Email",
//       contactNumberElement: "Contact Number",
//       alternativeNumberElement: "Alternative Contact Number",
//       webisteElement: "Webiste",
//       instagramElement: "Instagram",
//       regionRating: "Partner Rating",
//       thumbnailImageLandingPageElement:
//         "Landing Page Filter Thumbnail (160 x 190 px)",
//       thumbnailImageListingPageElement:
//         "Partner Listing Page Thumbnail - Desktop (450 x 380 px)",
//       thumbnailImageListingPageMobileElement:
//         "Partner Listing Page Thumbnail - Mobile (400 x 200 px)",
//       thumbnailImageDetailPageElement:
//         "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)",
//       thumbnailImageDetailPageMobileElement:
//         "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)",
//       thumbnailImageBottomBannerDesktopElement:
//         "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)",
//       thumbnailImageBottomBannerMobileElement:
//         "Partner Detail Page- Bottom Banner - Mobile - (450 x 480 px)",
//       thumbnailImageVideoPosterElement:
//         "Thumbnail - Partner Detail - Video Poster Image - (1920 x600 px)",
//       countryWhereBusinessOperatesElement:
//         "Country where business operates",
//       countryOfferServices: "Countries where you offer your services",
//       businessEstablishedYear: "Year your Business was established",
//       reMotercycleFleet:
//         "Which RE motorcycles model do you have within your fleet? (Multiple)",
//       nonGuidedTourElement:
//         "Do you offer motorcycle rental for non-guided tours?",
//       guidedToursOfferedElement: "Guided tours offered",
//       selfRentalElement: "Self rental options",
//       regionElement: "Region",
//       galleryImages: "Gallery Common",
//       videoElement: "Video",
//       backElement: "Back",
//     },
//     partnerListElement: {
//       partnerHeadingElement: "Partners",
//       addNewElement: "Add New",
//       filterButtonElement: "Filter",
//       totalCountElement: "Total Count - ",
//       countryElement: "Country",
//       selectCountryElementt: "Select Country",
//       emailElement: "Email",
//       emailPlaceholder: "Email",
//       phoneElement: "Phone",
//       phonePlaceholder: "Phone",
//       searchButtonElement: "Search",
//       clearFilterButtonElement: "Clear Filter",
//       pendingElement: "Pending",
//       approvedElement: "Approved",
//       rejectedElement: "Rejected",
//        modifiedElement: "Modified",
//       partnerTitlelement: "Partner",
//       emailTitleElement: "Email",
//       phoneTitleElement: "Phone",
//       countryTitleElement: "Country",
//       statusTitleElement: "Status",
//       noRecordsFoundElement: "No records to display",
//       actionsElement: "Actions",
//       rejectionModelLabel: "Rejection Reason",
//       rejectModelButtonElement: "Reject",
//     },
//     validationsElement: {
//       emailRequiredValidation: "Email is required",
//       notValidEmailValidation: "Please enter valid email",
//       invalidContactNumberValidation: "Invalid contact number",
//       contactNumberLengthValidation:
//         "Contact number should be between 8 - 15 characters",
//       regionRatingValidation: "Region rating is required",
//       countryRatingValidation: "Country rating is required",
//       establishedYearValidation: "Establish year is required",
//       nameValidation: "The name must contain only Alphabets",
//       maxLengthValidation: "Max length is 150",
//       thumbnailImageSizeValidation:
//         "The size of the image should be less than 1 mb",
//       videoSizeValidation:
//         "The size of the video should be less than 10 mb",
//     },
//     partnerDetailsElements: {
//       headingElement: "Partner Detail",
//       businessNameElement: "Business Name",
//       emailElement: "Email",
//       phoneElement: "Phone",
//       countryElement: "Country",
//       backElement: "Back",
//       editElement: "Update",
//       deleteElement: "Delete",
//       moderateElement: "Moderate",
//     },
//     partnerPersonalFormElement: {
//       headingElement: "Partner Personal Information",
//       subHeadingUserElement: "Personal Details",
//       businessNameElement: "Business Name",
//       businessNamePlaceholder: "Business Name",
//       shotBioElement: "Short Bio (Profile) Of Your Business",
//       shortBioPlaceholder: "Short Bio (Profile) Of Your Business",
//       emailLabel: "Email",
//       emailPlaceholder: "Email",
//       contactNumberElement: "Contact Number",
//       altContactNumberElement: "Alternative Contact Number",
//       currentLocationElement: "Current Location",
//       currentLocationLatitudeElement: "Current Location Latitude",
//       currentLocationLongitudeElement: "Current Location Longitude",
//       websiteElement: "Website",
//       websitePlaceholder: "https://www.example.com",
//       instagramAccountElement: "Instagram Account",
//       subHeadingBusinessElement: "Business Details",
//       partnerRatingElement: "Partner Rating",
//       businessOperatesCountries: "Country Where Business Operates",
//       countryLabel: "All Countries",
//       regionLabel: "Region",
//       countryOfferServices: "Countries Where You Offer Your Services",
//       businessEstablishedYear: "Year Your Business Was Established:",
//       reMotorcycleModel:
//         "Which RE Motorcycles Model Do You Have Within Your Fleet? (Multiple)",
//       noGuidedToursElement:
//         "Do You Offer Motorcycle Rental For Non-Guided Tours?",
//       yesElement: "Yes",
//       noElement: "No",
//       guidedTourOfferedElement: "Guided Tours Offered",
//       selfRentalElement: "Self Rentals Options",
//       uploadMediaHeading: "Upload Media",
//       thumbnailImageLandingPageElement:
//         "Landing Page Filter Thumbnail (160 x 190 px)",
//       thumbnailImageFormatElement:
//         "Format: JPG JPEG PNG WEBP. Max Size: 1MB.",
//       thumbnailImageListingPageElement:
//         "Partner Listing Page Thumbnail - Desktop (450 x 380 px)",
//       thumbnailImageListingPageMobileElement:
//         "Partner Listing Page Thumbnail - Mobile (400 x 200 px)",
//       thumbnailImageDetailPageElement:
//         "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)",
//       thumbnailImageDetailPageMobileElement:
//         "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)",
//       galleryImagesElement: "Gallery Common",
//       galleryImageFormatElement:
//         "Max 20 images allowed. Format: JPG JPEG PNG WEBP. Max Size: 1MB.",
//       partnerDetailImageFormatElement:
//         "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)",
//       partnerDetailMobileImageFormatElement:
//         "Partner Detail Page- Bottom Banner -  Mobile - (450 x 480 px)",
//       PartnerdetailVideoImagesElement:
//         "Partner Detail Page - Video Poster Image - (1920 x 600 px)",

//       uploadVideosElement: "Upload Videos (1920 x 600 px)",
//       uploadVideosFormatElement:
//         "Only one file allowed. Format: Mp4. Max Size: 10MB.",
//       backButtonElement: "Back",
//       submitButtonElement: "Submit",
//       previewButtonElement: "Preview",
//       searchPlacesElement: "Search Places ...",
//       thumbnailImageUploadValidation:
//         "Only 1 image is allowed to upload",
//       imageUploadvalidation: "Max 20 images are allowed to be upload",
//       videoUploadValidation: "Only 1 video is allowed to upload",
//       businessNameValidationElement: "Please enter business name",
//       emailValidationElement: "Please enter email address",
//       contactNumberValidationElement: "Please enter contact number",
//       currentLocationValidationElement: "Please enter current location",
//       webisteValidationElement: "Please enter website address",
//       instaValidationElement: "Please enter instagram account details",
//       regionRatingValidationElement: "Please select Partner Rating",
//       countryBusinessOperatesValidationElement:
//         "Please select country where business operates",
//       regionValidationElement: "Please select region",
//       countryBusinessOfferesValidationElement:
//         "Please select countries where business offer services",
//       establishedYearValidationElement:
//         "Please select established year",
//       videoDimensionValidationElement:
//         "Video dimensions must be equal to",
//       videoSizeValidationElement:
//         "The size of the video should be less than 10 mb",
//       videoDimensionAndSizeValidationElement:
//         "The size of the video should be less than 10 mb & Video dimensions must be equal to",
//       galleryImageSizeValidationElement:
//         "The size of the image should be less than 1 mb",
//       galleryImageDimensionValidationElement:
//         "Image dimensions must be equal to",
//       galleryImageDimensionAndSizeValidationElement:
//         "The size of the image should be less than 1 mb & Image dimensions must be equal to",
//       imagesLengthElement: "Only 1 image is allowed to upload",
//       reMotocycleValidationElement:
//         "Please select the royal enfield motorcycles you have within your fleet",
//     },
//     testimonialDetailsElement: {
//       subheadingElement: "Partner Detail",
//       nameElement: "Name",
//       emailElement: "Email",
//       testimonialSubheadingElement: "Testimonial Detail",
//       riderNameElement: "Rider Name",
//       riderLocationElement: "Rider Location",
//       postedDateElement: "Posted Date",
//       riderNoteElement: "Rider Note",
//       riderImageElement: "Rider Image/Default image",
//       backElement: "Back",
//       editElement: "Edit",
//       deleteElement: "Delete",
//       moderateElement: "Moderate"
//     },
//     tourDetailElement: {
//       partnerHeadingElement: "Partner Detail",
//       nameLabel: "Name",
//       emailLabel: "Email",
//       tourDetailHeadingElement: "Tour Detail",
//       startLocationLabel: "Start Location",
//       startLoactionLatitudeLabel: "Start Location Latitude",
//       startLocationLongitudeLabel: "Start Location Longitude",
//       endLocationLabel: "End Location",
//       endLocationLatitudeLabel: "End Location Latitude",
//       endLocationLongitudeLabel: "End Location Longitude",
//       startDateLabel: "Start Date",
//       endDateLabel: "End Date",
//       regionLabel: "Region",
//       countryLabel: "Country",
//       distanceCoveredLabel: "Estimated Distance Covered (KM)",
//       descriptionLabel: "Description",
//       redirectionUrlLabel: "Redirection Url",
//       mediaHeading: "Media",
//       thumbnailImageHeading:
//         "Thumbnail - Tour Landing - Common - (160 x 190 px)",
//       galleryImageHeading: "Gallery Images Common",
//       thumbnailPartnerImageHeading:
//         "Thumbnail - Partner Detail - Tour Listing - Common - (360 x 310 px)",
//       backLabel: "Back",
//       editLabel: "Update",
//       moderateLabel: "Moderate",
//       deleteLabel: "Delete",
//     },
//     expDetailElement: {
//       partnerHeadingElement: "Partner Detail",
//       nameLabel: "Name",
//       emailLabel: "Email",
//       expDetailHeadingElement: "Experience Detail",
//       startLocationLabel: "Start Location",
//       startLoactionLatitudeLabel: "Start Location Latitude",
//       startLocationLongitudeLabel: "Start Location Longitude",
//       endLocationLabel: "End Location",
//       endLocationLatitudeLabel: "End Location Latitude",
//       endLocationLongitudeLabel: "End Location Longitude",
//       startDateLabel: "Start Date",
//       endDateLabel: "End Date",
//       regionLabel: "Region",
//       countryLabel: "Country",
//       distanceCoveredLabel: "Estimated Distance Covered (KM)",
//       descriptionLabel: "Description",
//       redirectionUrlLabel: "Redirection Url",
//       mediaHeading: "Media",
//       thumbnailImageHeading:
//         "Thumbnail - Experience Landing - Common - (160 x 190 px)",
//       galleryImageHeading: "Gallery Images Desktop",
//       thumbnailPartnerDetailImageHeading:
//         "Thumbnail - Partner Detail - Experience Listing - Common - (360 x 310 px)",
//       backLabel: "Back",
//       editLabel: "Update",
//       moderateLabel: "Moderate",
//       deleteLabel: "Delete",
//     },
//     partnerDimensionalElement: {
//       thumbnailPageWidthElement: 160,
//       thumbnailPageHeightElement: 190,
//       thumbnailListingPageWidthElement: 450,
//       thumbnailListingPageHeightElement: 380,
//       thumbnailListingPageWidthMobileElement: 400,
//       thumbnailListingPageHeightMobileElement: 200,
//       thumbnailDetailPageWidthElement: 1920,
//       thumbnailDetailPageHeightElement: 620,
//       thumbnailDetailPageWidthMobileElement: 450,
//       thumbnailDetailPageHeightMobileElement: 800,
//       thumbnailDetailPageBottomWidthElement: 1920,
//       thumbnailDetailPageBottomHeightElement: 600,
//       thumbnailDetailPageBottomWidthMobileElement: 450,
//       thumbnailDetailPageBottomHeightMobileElement: 480,
//       galleryWidthElement: 350,
//       galleryHeightElement: 450,
//       partnerDetailPageVideoWidthElement: 1920,
//       partnerDetailPageVideoHeightElement: 600,
//       videoWidthElement: 1920,
//       videoHeightElement: 600,
//     },
//     tourDimensionalElement: {
//       tourLandingThumbnailPageWidthElement: 160,
//       tourLandingThumbnailPageHeightElement: 190,
//       galleryWidthElement: 850,
//       galleryHeightElement: 330,
//       partnerDetailTourListingThumbnailWidthElement: 360,
//       partnerDetailTourListingThumbnailHeightElement: 310,
//     },
//     experienceDimensionalElement: {
//       experienceLandingThumbnailPageWidthElement: 160,
//       experienceLandingThumbnailPageHeightElement: 190,
//       galleryWidthElement: 850,
//       galleryHeightElement: 330,
//       partnerDetailExperienceListingThumbnailWidthElement: 360,
//       partnerDetailExperienceListingThumbnailHeightElement: 310,
//     },
//     testimonialDimensionalElement: {
//       riderImageWidthElement: 80,
//       riderImageHeightElement: 80,
//     },
//   },
// }
